
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SpeciesManager } from "./options/SpeciesManager";
import { RolesManager } from "./options/RolesManager";
import { AgeGroupsManager } from "./options/AgeGroupsManager";
import { ColorThemesManager } from "./options/ColorThemesManager";

export const CharacterOptionsManager = () => {
  return (
    <div className="admin-container space-y-4 md:space-y-6">
      <div>
        <h2 className="text-xl md:text-2xl font-bold">Character Options Management</h2>
        <p className="text-gray-600 text-sm mt-1">
          Manage character field options and categories
        </p>
      </div>

      <Tabs defaultValue="species" className="space-y-4">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="species">Species</TabsTrigger>
          <TabsTrigger value="roles">Roles</TabsTrigger>
          <TabsTrigger value="ageGroups">Age Groups</TabsTrigger>
          <TabsTrigger value="colorThemes">Color Themes</TabsTrigger>
        </TabsList>

        <TabsContent value="species">
          <SpeciesManager />
        </TabsContent>

        <TabsContent value="roles">
          <RolesManager />
        </TabsContent>

        <TabsContent value="ageGroups">
          <AgeGroupsManager />
        </TabsContent>

        <TabsContent value="colorThemes">
          <ColorThemesManager />
        </TabsContent>
      </Tabs>
    </div>
  );
};
